import {GRANITE_3, GRANITE_7, GRANITE_8} from '@gaia/colors';
import theme from '@gaia/theme';
import {closeButtonZIndex} from '@gaia/utils/gaia/zIndices';
import CloseIcon from '@mui/icons-material/Close';
import {IconButton, type IconButtonProps} from '@mui/material';

export interface CloseButtonProps extends IconButtonProps {
    low?: boolean;
    withBackground?: boolean;
}

export default function CloseButton({withBackground = true, ...props}: CloseButtonProps) {
    return (
        <IconButton
            aria-label='Close sidebar'
            sx={{
                padding: theme.spacing(0.5),
                zIndex: closeButtonZIndex,
                boxShadow: theme.shadows[3],
                backgroundColor: withBackground ? GRANITE_8 : '',
                '&:hover': {backgroundColor: GRANITE_7},
            }}
            {...props}
            size='large'
        >
            <CloseIcon
                style={{
                    color: GRANITE_3,
                }}
            />
        </IconButton>
    );
}
